import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskNotificationsCustomerNotificationsRoute: InvariantJiraRoute =
	{
		name: 'project-settings-servicedesk-notifications-customer-notifications',
		path: '/jira/servicedesk/projects/:projectKey/settings/notifications/customer-notifications',
	};
